import React from "react";
import DOMPurify from "dompurify";

/**
 * Sicheres Rendering von WYSIWYG-Inhalten.
 * - Akzeptiert HTML (mit Tags wie <p>, <h2>, <strong>, <ul>, …) und stellt es per dangerouslySetInnerHTML dar.
 * - Akzeptiert auch reinen Plain-Text (Backwards-Compatibility): wenn keine HTML-Tags erkennbar sind,
 *   werden Zeilenumbrüche per `whitespace-pre-line` erhalten.
 */
const ALLOWED_TAGS = ["p", "br", "div", "strong", "b", "em", "i", "u", "h2", "h3", "ul", "ol", "li", "a"];
const ALLOWED_ATTR = ["href", "target", "rel"];

function looksLikeHtml(s) {
  if (!s) return false;
  return /<\/?(p|h2|h3|ul|ol|li|strong|em|b|i|u|a|br|div)\b/i.test(s);
}

export default function RichText({ html, className = "", testid }) {
  if (!html) return null;
  if (!looksLikeHtml(html)) {
    return (
      <div className={`whitespace-pre-line ${className}`} data-testid={testid}>
        {html}
      </div>
    );
  }
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ["target", "rel"],
  });
  return (
    <div
      className={className}
      data-testid={testid}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
